// pages/admin/Settings.js


import React, { useEffect, useState } from "react";
import { getSystemNotice, setSystemNotice } from "../../api/ragApi";
import "../../style/settings.css";


export default function Settings() {
  const [systemNotice, setNotice] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const msg = await getSystemNotice();
        setNotice(msg);
      } catch (err) {
        console.error("Notice load error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchNotice();
  }, []);

  const update = async () => {
    setSaving(true);
    try {
      // TODO: Replace with actual admin token
      const token = localStorage.getItem("admin_token");
      await setSystemNotice(systemNotice, token);
      alert("System notice updated");
    } catch (err) {
      console.error(err);
      alert("Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loader">Loading settings...</div>;
  }

  return (
    <div className="admin-page settings-page">

      <h2 className="page-title">System Settings</h2>

      {/* ================= CREDIT CONFIG ================= */}
      <div className="settings-card">
        <h4>Credit Configuration</h4>



        {/* Max Guest Credits input removed. Only system notice remains. */}
      </div>

      {/* ================= SYSTEM NOTICE ================= */}

      <div className="settings-card">
        <h4>System Notice</h4>
        <textarea
          className="settings-textarea"
          placeholder="Enter system-wide notice..."
          value={systemNotice}
          onChange={e => setNotice(e.target.value)}
        />
      </div>
      <button className="btn-primary" onClick={update} disabled={saving}>
        {saving ? "Saving..." : "Save Changes"}
      </button>

    </div>
  );
}